import styles from "./index.module.css";
import { useAudio } from "../audio-provider/hooks";
import { useVisualizer } from "./hooks";
import { usePlaylist } from "../../music/playlist-provider/hooks";
import { useMusic } from "../../../hooks/music/use-music";
import { forwardRef, useEffect } from "react";
import { useDrag } from "../../ui/drag/hooks";
import { useDragPosition } from "../../../hooks/dom/use-drag-position";
import { useIsDragging } from "../../../hooks/dom/use-is-dragging";

export const Visualizer = forwardRef<HTMLDivElement>((_, ref) => {
  const audio = useAudio();
  const playlist = usePlaylist();
  const drag = useDrag();

  const { currentMusic } = useMusic(playlist);

  const { low, mid } = useVisualizer(audio);

  const [x, y] = useDragPosition(drag);
  const isDragging = useIsDragging(drag);

  useEffect(() => {
    audio.panner.pan = [x / 200, -y / 200];
  }, [audio, x, y]);

  return (
    <div className={styles.container}>
      <div
        ref={ref}
        style={{
          transform: `translate(${x}px, ${y}px)`,
        }}
        className={styles.wrapper}
        data-dragging={isDragging}
      >
        <div className={styles["mid-frequency-visualizer__wrapper"]}>
          <div
            className={styles["mid-frequency-visualizer"]}
            style={{
              transform: `scale(${mid})`,
            }}
          />
        </div>

        <div
          className={styles["low-frequency-visualizer"]}
          style={{
            transform: `scale(${low})`,
          }}
        >
          <img
            src={currentMusic.thumbnail}
            alt={currentMusic.title}
            className={styles["thumbnail"]}
            draggable={false}
          />
        </div>
      </div>
    </div>
  );
});
